// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const grumpig: PokeData = {
  "id": 326,
  "name": "grumpig",
  "height": 9,
  "weight": 715,
  "base_experience": 165,
  "types": [
    PokeType.PSYCHIC
  ],
  "api_moves": [
    "growl",
    "psybeam",
    "confusion",
    "psychic",
    "confuse-ray",
    "psywave",
    "splash",
    "rest",
    "snore",
    "psych-up",
    "magic-coat",
    "teeter-dance",
    "odor-sleuth",
    "bounce",
    "payback",
    "power-gem",
    "zen-headbutt",
    "psyshock",
    "belch"
  ],
  "moves": [
    "growl",
    "psychic",
    "confuse-ray",
    "psywave",
    "splash",
    "zen-headbutt",
    "synchronize",
    "healing-wish",
    "prismatic-cage",
    "psy-pulse",
    "calm-mind",
    "psychic-fangs",
    "reflect"
  ],
  "evolution_chain": {
    "id": 164,
    "item": null,
    "species": [
      {
        "name": "spoink",
        "order": 353,
        "types": [
          PokeType.PSYCHIC
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "grumpig",
        "order": 354,
        "types": [
          PokeType.PSYCHIC
        ],
        "evolves_from_species_id": 325,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 32,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 132,
    "speed": 126,
    "ability_power": 142
  },
  "stat_changes": [],
  "catch_rate": 60,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
